module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096J1N114.11e725b7.jpg";